export * from '@optios-frontend-website/shared-ui/src/constants'

export const WEBSITE_GALLERY = 'WEBSITE_GALLERY'
export const WEBSITE_BANNER = 'WEBSITE_BANNER'
export const WEBSITE_LOGO = 'WEBSITE_LOGO'
export const WEBSITE_PHOTO = 'WEBSITE_PHOTO'
export const WEBSITE_BACKGROUND_IMAGE = 'WEBSITE_BACKGROUND_IMAGE'
export const WEBSITE_EMPLOYEE = 'WEBSITE_EMPLOYEE'
export const WEBSITE_BUTTON = 'WEBSITE_BUTTON'
